import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingArray: HTMLIonLoadingElement[] = []; // Array to store active loadings


  constructor(
    public loadingController: LoadingController
  ) { }
  async presentLoading(msg) {
    await this.dismissLoader()
    const loading = await this.loadingController.create({
      message: 'Loading...',
    });

    this.loadingArray.push(loading); // Add loading to array
    await loading.present();
  }

  async dismissLoader() {
    const loading = this.loadingArray.pop(); // Get the latest loading from the array

    if (loading) {
      await loading.dismiss();

      // Dismiss all other loadings
      this.loadingArray.forEach(async (loadingItem) => {
        await loadingItem.dismiss();
      });

      this.loadingArray = []; // Clear the loading array
    }
  }

//   async presentLoading(
//     messsage,
//     options= {},
//     onDidDismiss: (res) => any = (res) => {}
//   ) {
   
//     this.loading = await this.loadingController.create({
//       message: messsage,
     
//       ...options
//     });

//     this.loading.onDidDismiss().then((res) => {
//       onDidDismiss(res);
//     });

//     return this.loading.present();
// /*     return Promise.resolve(); */
//   }

//   async dismissLoader() {
//     if (this.loading) {
//       return this.loading.dismiss();
//     }
//     return Promise.resolve();
//   }
  
}
